import conversionTable from './conversionTable'

/**
 *
 * Converts numerical values from one unit to another.
 * Units can be converted within the following groups:
 *
 * - distance: 'meters', 'kilometers', 'feet', 'yards', 'miles'
 * - time: 'hours', 'minutes', 'seconds'
 * - energy: 'kilocalories', 'kilojoule'
 *
 * Example:
 *
 * convert(23)
 *   .from('meters')
 *   .to('kilometers')
 *
 * or:
 *
 * convert(23, { from: 'meters', to: 'kilometers' })
 *
 * // -> 0.023
 *
 * @param  {Number} value   - the numerical value to be converted
 * @param  {Object} options - ex: { from: 'meters', to: 'kilometers' }
 * @return {Number}
 */
export default function convert (value, options) {
  // literate api
  if (!options) {
    return ({
      from: (from) => ({
        to: (to) => convert(value, { from, to }),
      }),
    })
  }

  const { from, to } = options
  const _from = from.toLowerCase()
  const _to = to.toLowerCase()

  if (_from === _to) { return value } // short-circuit if values are same

  if (!conversionTable[_from]) {
    throw new Error(`Unable to convert from unit: "${from}"`)
  }

  const factor = conversionTable[_from][_to]

  if (typeof factor === 'function') {
    return factor(value)
  } else {
    return value * factor
  }
}
